import { render, staticRenderFns } from "./driver_manager_risk_matrix_help.vue?vue&type=template&id=e08ebb9e&scoped=true&"
import script from "./driver_manager_risk_matrix_help.vue?vue&type=script&lang=js&"
export * from "./driver_manager_risk_matrix_help.vue?vue&type=script&lang=js&"
import style0 from "./driver_manager_risk_matrix_help.vue?vue&type=style&index=0&id=e08ebb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08ebb9e",
  null
  
)

export default component.exports